import type PublishingSettings from 'owa-service/lib/contract/PublishingSettings';
import type { BookingBusinessEntryInput } from 'owa-graph-schema';
import mapSchedulingPolicy from './mapSchedulingPolicy';
import mapThemeDataType from './mapThemeDataType';
import mapSelfServicePageAuthType from './mapSelfServicePageAuthType';
import mapOtpSettings from './mapOtpSettings';
import mapOtpSettingsToBookingEmailVerificationMethod from './modelA/mapOtpSettingsToBookingEmailVerificationMethod';
import { getUserConfiguration } from 'owa-session-store';
import type FeatureSource from '../constants/source';
import mapOnDemandServicesSetting from './modelA/mapOnDemandServicesSetting';

const mapPublishingSettings = (
    publishingSettings: PublishingSettings,
    source?: string
): BookingBusinessEntryInput => {
    const {
        IsPublished,
        PublishedUrl,
        FriendlyUrl,
        DefaultSchedulingPolicy,
        Theme,
        IsLogoHidden,
        IsConsentNeeded,
        ConsentText,
        AuthType,
        CustomColorScheme,
        IsSearchEngineIndexabilityDisabled,
        OtpVerificationSetting,
        IsNewC2RevampedEnabled,
        ShowTimeSlotsInBusinessTimeZone,
        OnDemandServicesSetting,
    } = publishingSettings;

    const bookingMailboxId =
        source == 'BookWithMe'
            ? getUserConfiguration().SessionSettings?.UserPrincipalName ?? ''
            : getUserConfiguration().ViewStateConfiguration?.SelectedBookingMailbox ?? '';

    const modifiedPublishingSettings = {
        id: bookingMailboxId,
        isPublished: IsPublished,
        schedulingPolicy: mapSchedulingPolicy(DefaultSchedulingPolicy),
        settings: {
            otpVerificationSetting: mapOtpSettings(OtpVerificationSetting),
            publishingUrl: PublishedUrl,
            themeData: mapThemeDataType(Theme),
            c2RevampedEnabled: IsNewC2RevampedEnabled,
            authType: mapSelfServicePageAuthType(AuthType),
            friendlyUrl: FriendlyUrl,
            isLogoHidden: IsLogoHidden,
            isConsentNeeded: IsConsentNeeded,
            consentText: ConsentText,
            customColorScheme: CustomColorScheme,
            isSearchEngineIndexabilityDisabled: IsSearchEngineIndexabilityDisabled,
            showTimeSlotsInBusinessTimeZone: ShowTimeSlotsInBusinessTimeZone,
            /**
             * In model A, we are not updating the EmailVerificationMethod anywhere from c1
             * but at backend OptVerificationSetting is mapped to EmailVerificationMethod and then EmailVerificationMethod is used everywhere.
             * In B2, this mapping this not done at backend so we are sending the mapped value from client itself.
             */
            emailVerificationMethod: mapOtpSettingsToBookingEmailVerificationMethod(
                OtpVerificationSetting,
                source
            ),
            sendMeetingInviteToCustomer: DefaultSchedulingPolicy?.SendMeetingInviteToCustomer,
            onDemandServicesSetting: mapOnDemandServicesSetting(OnDemandServicesSetting),
        },
    };

    return modifiedPublishingSettings;
};

export default mapPublishingSettings;
